<template>
  <div
    v-if="canInstall || showIosInstructions"
    class="fixed z-40 left-3 right-3 bottom-[70px] md:left-auto md:right-4 md:bottom-4 md:w-[340px]"
  >
    <div class="relative flex items-center gap-3 bg-sheet rounded-xl shadow-ink border border-border p-3 pr-8">
      <img :src="appPath('favicon-192x192.png')" alt="" class="w-11 h-11 rounded-md shadow-ink-sm shrink-0 object-cover" />
      <div class="min-w-0 flex-1">
        <p class="text-[13px] font-semibold leading-tight">{{ $t('app.install.title') }}</p>

        <template v-if="canInstall">
          <p class="text-[11px] text-ink2 leading-tight mt-0.5">{{ $t('app.install.subtitle') }}</p>
          <button
            type="button"
            class="mt-2 px-3 py-1.5 rounded-md bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] text-[12px] font-semibold active:scale-95 transition-transform"
            @click="promptInstall"
          >
            {{ $t('app.install.installButton') }}
          </button>
        </template>

        <!-- iOS не поддерживает beforeinstallprompt - показываем только инструкцию, без кнопки. -->
        <p v-else class="text-[11px] text-ink2 leading-tight mt-0.5 flex items-start gap-1">
          <Share class="w-3 h-3 shrink-0 mt-0.5" />
          <span>{{ $t('app.install.iosInstructions') }}</span>
        </p>
      </div>
      <button
        type="button"
        class="absolute top-2 right-2 text-ink2 hover:text-[hsl(var(--foreground))]"
        :aria-label="$t('app.install.dismissLabel')"
        @click="dismiss"
      >
        <X class="w-4 h-4" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Share, X } from "lucide-vue-next";
import { useInstallPrompt } from "../composables/useInstallPrompt";
import { appPath } from "../utils/appPath";

const { canInstall, showIosInstructions, promptInstall, dismiss } = useInstallPrompt();
</script>
